import React, { ReactNode } from "react";
import { PortalFunctionParams } from "react-portal";
import {
  BoundingRectContext,
  StyledPortal,
} from "@sonder/ui/source/styled/components/PortalWithTrigger";

interface PortalWithBoundingRectProps extends PortalFunctionParams {
  boundingRect: Omit<DOMRect, "toJSON">;
  className?: string;
  children: ReactNode;
}

export const PortalWithBoundingRect = ({
  boundingRect,
  children,
  portal,
}: PortalWithBoundingRectProps) => {
  const style = {
    left: boundingRect.left,
    minWidth: boundingRect.width,
    top: boundingRect.top,
  };
  return portal(
    <StyledPortal onClick={e => e.stopPropagation()} {...style}>
      <BoundingRectContext.Provider value={boundingRect}>
        {children}
      </BoundingRectContext.Provider>
    </StyledPortal>,
  );
};
